"use client";

import { c as _c } from "react/compiler-runtime";
import { ComboboxShortcut, classNames, Input, Media, tv, useIsGreaterThanOrEqualToLg } from "@opensea/ui-kit";
import { Search } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useExpandedSearchStore } from "@/components/expanded-search/ExpandedSearchStore";
import { useTopNavbarVariants } from "./utils";
const navSearchVariants = tv({
  slots: {
    input: classNames("w-full cursor-text rounded-md bg-white pr-2 backdrop-blur-lg lg:min-w-[120px] lg:max-w-[360px] dark:bg-bg-primary-transparent", "transition-[background-color,box-shadow] duration-150 ease-out"),
    inputField: "pointer-events-none text-sm text-text-primary placeholder:text-text-primary",
    icon: "fill-text-primary",
    shortcut: "border border-border-1-transparent bg-additional-1-transparent text-text-primary"
  },
  variants: {
    variant: {
      default: {
        input: ""
      },
      always: "",
      none: "",
      hidden: "",
      topOnly: "",
      invisible: ""
    }
  }
});
export function NavSearch() {
  const $ = _c(9);
  const t = useTranslations("NavSearch");
  const isMobile = useIsGreaterThanOrEqualToLg();
  let t0;
  if ($[0] !== isMobile) {
    t0 = {
      isMobile
    };
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    transparent
  } = useTopNavbarVariants(t0);
  const {
    input,
    inputField,
    icon,
    shortcut
  } = navSearchVariants({
    variant: transparent
  });
  const setOpen = useExpandedSearchStore(_temp);
  const t1 = input();
  let t2;
  if ($[2] !== setOpen) {
    t2 = () => {
      setOpen(true);
    };
    $[2] = setOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("searchPlaceholder");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const T0 = Search;
  const t4 = icon();
  let t5;
  if ($[6] !== T0 || $[7] !== t4) {
    t5 = <T0 className={t4} size={18} />;
    $[6] = T0;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return <Media greaterThanOrEqual="lg"><Input autoComplete="off" className={t1} data-testid="NavSearch" endEnhancer={<ComboboxShortcut className={shortcut()}>/</ComboboxShortcut>} onClick={t2} overrides={{
      Input: {
        className: inputField()
      }
    }} placeholder={t3} startEnhancer={t5} variant="transparent" /></Media>;
}
function _temp(state) {
  return state.setOpen;
}